module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Design/Adjust-356c5c7ea82e578261695e79956ce550.svg";